export default __webpack_public_path__ + "cdff442e2eea87a0e306835ae961eeca.svg";